var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/* eslint-disable max-params */
import { lazy as ReactLazy, useCallback, useRef, useState } from 'react';
import { useEffectOnceWhen } from 'rooks';
import { singletonTTIPromises, DELAYS } from '../../../utils/tti';
import { loadRemoteModule as loadModule } from '../helpers/remote';
//@ts-ignore
import { noop } from '@mindtickle/utils';
var fallbackModule = {
    default: function () { return null; },
};
// eslint-disable-next-line max-params
function useRemoteInitialisation(remote, isManifestReady, lazy, maxDelay, shouldFailSilently, moduleEvaluationTimingCallback) {
    if (shouldFailSilently === void 0) { shouldFailSilently = false; }
    if (moduleEvaluationTimingCallback === void 0) { moduleEvaluationTimingCallback = noop; }
    var _a = __read(useState(false), 2), isReadyForRendering = _a[0], setReadyForRendering = _a[1];
    var _b = __read(useState(false), 2), downloadCompleted = _b[0], setDownloadCompleted = _b[1];
    var moduleDetailsRef = useRef(undefined);
    var getModuleDetails = useCallback(function () {
        var module = loadModule(remote.remoteName, remote.moduleName, moduleEvaluationTimingCallback);
        return {
            module: module,
            Component: ReactLazy(function () {
                return module
                    .then(function (_module) {
                    setDownloadCompleted(true);
                    return _module;
                })
                    .catch(function (error) {
                    if (shouldFailSilently) {
                        return fallbackModule;
                    }
                    throw new Error(error);
                });
            }),
        };
    }, [remote.moduleName, remote.remoteName, shouldFailSilently, moduleEvaluationTimingCallback]);
    var updateModuleDetails = useCallback(function () {
        if (!isReadyForRendering) {
            moduleDetailsRef.current = getModuleDetails();
            setReadyForRendering(true);
        }
    }, [isReadyForRendering, getModuleDetails]);
    useEffectOnceWhen(function () {
        var ttiPromise = singletonTTIPromises[maxDelay] || singletonTTIPromises[DELAYS.L];
        lazy ? ttiPromise.then(updateModuleDetails) : setTimeout(updateModuleDetails, 1);
    }, isManifestReady);
    return {
        isReadyForRendering: isReadyForRendering,
        downloadCompleted: downloadCompleted,
        moduleDetails: moduleDetailsRef.current,
    };
}
export default useRemoteInitialisation;
//# sourceMappingURL=useRemoteInitialisation.js.map